__webpack_require__.p = "/bit-mysteries/";